import {combineReducers} from 'redux';
import ajaxCallsInProgress from './ajaxStatusReducer';
import data from './dataReducer';
import promos from './promoReducer';
import {reducer as toastr} from 'react-redux-toastr'

const rootReducer = combineReducers({
    data,
    ajaxCallsInProgress,
    promos,
    toastr
});

export default rootReducer;
